import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import SellOutward from "./SellOutward";
import ProductionOutward from "./ProductionOutward";
import TransferOutward from "./TransferOutward";

const AddOutward = (props) => {
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (props.location?.state && props.location.state.OutwardType) {
      setTabIndex(props.location.state.OutwardType === "Sell" ? 0 : 1);
    }
  }, []);

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-inward-body">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div
          className="p-d-flex p-ai-center"
          onClick={() => {
            props.history.push("/admin/outward");
          }}
        >
          <i className="pi pi-arrow-right rotate" />
          <h2>Inventory Outward</h2>
        </div>
        <div className="outward-type-btn-group">
          <button
            type="button"
            className={`btn-group-tab${tabIndex === 0 ? " active" : ""}`}
            onClick={() => setTabIndex(0)}
          >
            Sell
          </button>
          {/* <button
          type="button"
          className={`btn-group-tab${tabIndex === 1 ? ' active' : ''}`}
          onClick={() => setTabIndex(1)}
        >
          Production
        </button> */}
          <button
            type="button"
            className={`btn-group-tab${tabIndex === 1 ? " active" : ""}`}
            onClick={() => setTabIndex(1)}
          >
            Transfer
          </button>
        </div>
      </div>
      <hr />
      {tabIndex === 0 && <SellOutward {...props} />}
      {/* {tabIndex === 1 && <ProductionOutward {...props} />} */}
      {tabIndex === 1 && <TransferOutward {...props} />}
    </div>
  );
};

export default AddOutward;
